<template>
    <div class="ui-body">
        <!-- 01.主体容器 - 头部 Start -->
        <div class="ui-container-header">
            <!-- 01.01.主体容器 - 头部 - 标题 Start -->
            <h3 class="ui-container-header-title"><i class="ion-ios-arrow-forward"></i>{{ this.$route.meta.title }}</h3>
            <!-- 01.01.主体容器 - 头部 - 标题 End -->
            <!-- 01.02.主体容器 - 头部 - 副标题 Start -->
            <p class="ui-container-header-subtitle">{{ this.$route.meta.description }}</p>
            <!-- 01.02.主体容器 - 头部 - 副标题 End -->
            <!-- 01.03.主体容器 - 头部 - 按钮组 Start -->
            <div class="ui-container-header-group" v-if="$Permissions(['RoleOperation'])">
                <el-button-group>
                    <el-button @click="operateAllCreate" v-if="$Permissions(['RoleOperationCreate'])"><i class="ion-ios-add-circle"></i>新增</el-button>
                    <el-dropdown @command="operateAllState" v-if="$Permissions(['RoleOperationState'])">
                        <el-button><i class="ion-ios-switch"></i>审核<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="adopt" v-if="$Permissions(['RoleOperationStateOn'])">批量审核</el-dropdown-item>
                            <el-dropdown-item command="failed" v-if="$Permissions(['RoleOperationStateOff'])">批量反审</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button @click="operateAllDelete" v-if="$Permissions(['RoleOperationDelete'])"><i class="ion-ios-close-circle"></i>删除</el-button>
                    <el-button @click="operateAllRefresh" v-if="$Permissions(['RoleOperationRefresh'])"><i class="ion-ios-refresh-circle"></i>刷新</el-button>
                </el-button-group>
            </div>
            <!-- 01.03.主体容器 - 头部 - 按钮组 End -->
        </div>
        <!-- 01.主体容器 - 头部 End -->

        <!-- 02.主体容器 - 内容 Start -->
        <div class="ui-container-content">
            <div class="ui-content">
                <!-- 02.01.主体容器 - 内容 - 搜索 Start -->
                <div class="ui-container-search">
                    <div class="ui-search-quick" v-if="$Permissions(['RoleSearch'])">
                        <!-- 02.01.01.快捷搜索 Start -->
                        <div class="ui-search-quick-input" v-if="$Permissions(['RoleSearchQuick'])">
                            <el-input placeholder="请输入友情链接编码 / 友情链接标题 ..." v-model="quickSearch" class="input-with-select">
                                <el-button type="primary" slot="append" icon="el-icon-search" @click="clickQuickSearch"></el-button>
                            </el-input>
                        </div>
                        <!-- 02.01.01.快捷搜索 End -->
                        <!-- 02.01.02.更多搜索切换 Start -->
                        <div class="ui-search-quick-button" v-if="$Permissions(['RoleSearchMore'])">
                            <el-button @click="searchState=!searchState">更多查询<i
                                    :class="searchState?'el-icon-arrow-up':'el-icon-arrow-down'"></i></el-button>
                        </div>
                        <!-- 02.01.02.更多搜索切换 End -->
                    </div>
                    <!-- 02.01.04.更多搜索表单 Start -->
                    <el-collapse-transition>
                        <div class="ui-search-more" v-show="searchState" v-if="$Permissions(['RoleSearchMore'])">
                            <el-scrollbar>
                                <el-form ref="arraySearch" :model="arraySearch" :label-position="searchPosition">
                                    <el-row :gutter="30">
                                        <el-col :span="8">
                                            <el-form-item label="链接" prop="link">
                                                <el-input v-model="arraySearch.link" placeholder="请输入友情链接链接"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="友情链接标题" prop="title">
                                                <el-input v-model="arraySearch.title" placeholder="请输入友情链接标题"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="审核状态" prop="state">
                                                <el-select v-model="arraySearch.state" clearable placeholder="请选择审核状态">
                                                    <el-option label="待审" value="0"></el-option>
                                                    <el-option label="通过" value="1"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-form>
                            </el-scrollbar>
                            <div class="ui-search-more-group">
                                <el-button type="primary" icon="ion-ios-search" @click="clickArraySearch">搜索</el-button>
                                <el-button icon="ion-ios-repeat" @click="resetArraySearch">重置</el-button>
                            </div>
                        </div>
                    </el-collapse-transition>
                    <!-- 02.01.04.更多搜索表单 End -->
                </div>
                <!-- 02.01.主体容器 - 内容 - 搜索 End -->
                <!-- 02.02.主体容器 - 内容 - 表格 Start -->
                <div class="ui-container-table" v-if="$Permissions(['RoleTable'])">
                    <el-table :data="tableData" height="100%" @selection-change="operateSelection" v-loading="tableLoading">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column prop="title" label="友情链接标题" width="320"></el-table-column>
                        <el-table-column prop="link" label="链接地址"></el-table-column>
                        <el-table-column prop="sort" label="排序" width="90" sortable></el-table-column>
                        <el-table-column prop="state" label="审核状态" width="100" v-if="$Permissions(['RoleTableState'])">
                            <template slot-scope="scope">
                                <el-switch v-model="scope.row.state" :active-value="true" :inactive-value="false" active-text inactive-text @change="operateState($event,scope.row.id)"></el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="150" v-if="$Permissions(['RoleTableOperation'])">
                            <template slot-scope="scope">
                                <el-button-group class="ui-table-button-group">
                                    <el-button size="mini" @click="operatePatch(scope.row.id)" v-if="$Permissions(['RoleTableOperationPatch'])">编辑</el-button>
                                    <el-button size="mini" @click="operateDelete(scope.row.id)" v-if="$Permissions(['RoleTableOperationDelete'])">删除</el-button>
                                </el-button-group>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <!-- 02.02.主体容器 - 内容 - 表格 End -->
            </div>
        </div>
        <!-- 02.主体容器 - 内容 End -->

        <!-- 03.主体容器 - 尾部 Start -->
        <div class="ui-container-footer ">
            <!-- 03.02.主体容器 - 尾部 - 分页 Start -->
            <div class="ui-container-footer-pagination">
                <el-pagination background :current-page="tablePage" :page-sizes="pageSizes" :page-size="pageSize" :total="tableTotal" layout="sizes, prev, pager, next, jumper, total" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
            </div>
            <!-- 03.02.主体容器 - 尾部 - 分页 End -->
        </div>
        <!-- 03.主体容器 - 尾部 End -->

        <!-- 数据新增 / 修改 Form start -->
        <el-dialog title="新增/修改友情链接" :visible.sync="formDialog" width="50%" :close-on-click-modal="false" v-if="$Permissions(['RoleOperationCreate','RoleTableOperationPatch'])">
            <el-form ref="formContent" :model="formContent" :label-width="formWidth" :label-position="formPosition"
                     :rules="formRules">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="友情链接标题" prop="title">
                            <el-input v-model="formContent.title" placeholder="请输入友情链接标题"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="排序" prop="sort">
                            <el-input v-model="formContent.sort" placeholder="请输入排序"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="友情链接链接" prop="link">
                            <el-input v-model="formContent.link" placeholder="请输入友情链接"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <template #footer>
                <span class="ui-dialog-footer">
                    <el-button type="primary" icon="ion-ios-checkmark-circle" @click="formRoleSubmit">{{ htmlSubmit }}</el-button>
                    <el-button icon="ion-ios-repeat" @click="onRoleReset">重置</el-button>
                </span>
            </template>
        </el-dialog>
        <!-- 数据新增 / 修改 Form end -->
    </div>
</template>

<script>
    export default {
        name: "data_link",
        data() {
            return {
                // 01.显示模式 ------------------------------------------------
                // 01.01.Html按钮标题
                htmlSubmit: "添加",
                // 01.02.TreeID
                treeID: "",
                // 01.数据搜索 ------------------------------------------------
                // 01.01.快捷搜索
                quickSearch: '',
                // 01.02.更多搜索
                arraySearch: {
                    title: '',
                    code: '',
                    state: ''
                },
                // 01.03.Search 显示状态
                searchState: false,
                // 01.04.Search 配置 - 标题位置
                searchPosition: 'top',
                // 02.数据数组 ------------------------------------------------
                // 02.01.数据数组 - 数据集
                tableData: [],
                // 02.02.数据数组 - 加载组件
                tableLoading: true,
                // 02.04.所选数据
                multipleTable: [],
                // 03.分页栏目 ------------------------------------------------
                // 03.01.分页栏目 - 当前页
                tablePage: 1,
                // 03.02.分页栏目 - 数据总量
                tableTotal: 400,
                // 03.03.分页栏目 - 每页数量条数
                pageSizes: [20, 50, 100, 200],
                // 03.04.分页栏目 - 分页条数
                pageSize: 20,
                // 04.数据上传/更新 ------------------------------------------------
                // 04.01.新增/修改状态
                formDialog: false,
                // 04.02.权限状态
                powerDialog: false,
                // 05.Form 配置/数据集 ------------------------------------------------
                // 05.01.Form提交API地址
                formAPI: '/api/create/link/',
                // 05.02.Form配置 - 标题位置
                formPosition: 'top',
                // 05.03.Form配置 - 标题宽度
                formWidth: '130px',
                // 05.04.Form数据集
                formContent: {
                    title: '',
                    link: '',
                    sort: '0'
                },
                // 05.05.Form 验证
                formRules: {
                    title: [
                        {required: true, message: '请输入友情链接标题', trigger: 'blur'}
                    ],
                    link: [
                        {required: true, message: '请输入友情链接', trigger: 'blur'}
                    ]
                },
            }
        },
        // 监控data中的数据变化
        watch: {
            // 01.树状框数据变化
            searchValue(val) {
                this.$refs.tree.filter(val)
            }
        },
        // 方法集合
        methods: {
            // 01.批量操作 ------------------------------------------------
            // 01.01.全选数据
            operateSelection(val) {
                this.multipleTable = []
                this.multipleSelection = val
                for (var i = 0; i < this.multipleSelection.length; i++) {
                    this.multipleTable.push(this.multipleSelection[i]['id'])
                }
            },
            // 01.02.新增
            operateAllCreate() {
                this.formDialog = true
                this.formAPI = '/api/create/link/'
                this.htmlSubmit = "新增"
                this.resetArraySearch()
            },
            // 01.04.批量导出
            operateAllDownload(command) {
                // 01.04.01.导出全部
                if (command === 'all') {
                    this.$confirm('是否批量导出全部数据？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$api.get("/api/download/link/").then((response) => {
                            this.$message.success(response.message)
                            window.open(this.$api_url + response.path)
                        })
                    }).catch(() => {

                    })
                }
                // 01.04.02.导出所选
                if (command === 'part') {
                    if (this.multipleTable.length === 0) {
                        this.$message.warning('请选择需要导出的数据')
                    } else {
                        this.$confirm('是否批量导出所选数据？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.$api.get("/api/download/link-active/", {'id': this.multipleTable}).then((response) => {
                                this.$message.success(response.message)
                                window.open(this.$api_url + response.path)
                            })
                        }).catch(() => {

                        })
                    }
                }
            },
            // 01.05.批量审核
            operateAllState(command) {
                // 01.05.01.批量审核
                if (command === 'adopt') {
                    if (this.multipleTable.length === 0) {
                        this.$message.warning('请选择需要审核的数据')
                    } else {
                        this.$confirm('是否批量审核所选数据？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.$api.get('/api/state/link-on/', {'id': this.multipleTable}).then((response) => {
                                this.$message.success(response)
                                this.operateAllRefresh()
                            })
                        }).catch(() => {

                        })
                    }
                }
                // 01.05.02.批量反审
                if (command === 'failed') {
                    if (this.multipleTable.length === 0) {
                        this.$message.warning('请选择需要反审的数据')
                    } else {
                        this.$confirm('是否批量反审所选数据？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.$api.get('/api/state/link-off/', {'id': this.multipleTable}).then((response) => {
                                this.$message.success(response)
                                this.operateAllRefresh()
                            })
                        }).catch(() => {

                        })
                    }
                }
            },
            // 01.06.批量删除
            operateAllDelete() {
                if (this.multipleTable.length === 0) {
                    this.$message.warning('请选择需要删除的数据')
                } else {
                    this.$confirm('是否批量删除所选数据？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$api.get('/api/delete/link-active/', {'id': this.multipleTable}).then((response) => {
                            this.$message.success(response)
                            this.operateAllRefresh()
                        })
                    }).catch(() => {

                    })
                }
            },
            // 01.07.刷新
            operateAllRefresh() {
                this.getTableJson()
            },
            // 02.表格操作 ------------------------------------------------
            // 02.01.编辑
            operatePatch(value) {
                this.formDialog = true
                this.getForm(value)
                this.formAPI = '/api/patch/link/?id=' + value
                this.htmlSubmit = "修改"
            },
            // 02.02.删除
            operateDelete(value) {
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$api.get('/api/delete/link/', {'id': value}).then((response) => {
                        this.$message.success(response)
                        this.operateAllRefresh()
                    })
                }).catch(() => {

                })
            },
            // 02.03.审核
            operateState(event, value) {
                this.$api.get('/api/state/link/', {'id': value, 'state': event}).then((response) => {
                    this.$message.success(response)
                    this.getTableJson()
                })
            },
            // 02.04.权限
            operatePower(value) {
                this.getPartPower(value)
                this.powerDialog = true
            },
            // 03.获取数据 ------------------------------------------------
            // 03.01.获取Json数据 ( tablePage 当前页  pageSize 分页条数  quickSearch 快捷搜索  arraySearch 更多搜索 )
            getTableJson() {
                this.arraySearch.quick_search = this.quickSearch
                this.arraySearch.table_page = this.tablePage
                this.arraySearch.page_size = this.pageSize
                this.$api.get('/api/get/link-array/', this.arraySearch).then((response) => {
                    this.tableData = response.data
                    this.pageSize = response.page_size
                    this.tableTotal = response.table_total
                    this.tablePage = response.table_page
                    this.tableLoading = false
                })
            },
            // 03.02.分页栏目 - 分页数
            changeSize(val) {
                // 01.赋值分页数
                this.pageSize = val
                // 02.获取Json数据
                this.getTableJson()
            },
            // 03.03.分页栏目 - 跳转页
            changeCurrent(val) {
                // 01.赋值跳转页
                this.tablePage = val
                // 02.获取Json数据
                this.getTableJson()
            },
            // 04.搜索/查询操作 ------------------------------------------------
            // 04.01.快捷搜索/查询
            clickQuickSearch() {
                // 01.获取Json数据
                this.getTableJson()
            },
            // 04.02.搜索/查询 - 查询提交
            clickArraySearch() {
                // 01.获取Json数据
                this.getTableJson()
                this.searchState = false
            },
            // 04.03.搜索/查询 - 重置Form表单
            resetArraySearch() {
                this.$refs['arraySearch'].resetFields()
                this.getTableJson()
                this.searchState = false
            },
            // 05.Form操作 ------------------------------------------------
            // 05.01.Form表单提交
            formRoleSubmit() {
                this.$refs['formContent'].validate((valid) => {
                    if (valid) {
                        this.$api.post(this.formAPI, this.formContent).then((response) => {
                            this.$message.success(response)
                            this.operateAllRefresh()
                        })
                    }
                })
            },
            // 05.02.重置Form表单
            onRoleReset() {
                this.$refs['formContent'].resetFields()
            },
            // 05.03.获取Form数据
            getForm(value) {
                this.$api.get('/api/get/link-data/', {'id': value}).then((response) => {
                    this.formContent.title = response.data[0].title
                    this.formContent.link = response.data[0].link
                    this.formContent.sort = response.data[0].sort
                })
            },
        },
        // 生命周期 - 挂载完成
        mounted() {
            // 01.获取Json数据
            this.getTableJson()
        },
    }
</script>
